/** Default incentive rules — mirrors apps/api/src/lib/incentives.ts */
export const INCENTIVE_RULES = {
  SURVEY_PAYOUT_RATE: 0.35,
  ELEVATED_PAYOUT_RATE: 0.40,
  SURVEY_PAYOUT_FLOOR: 10,
  REDEMPTION_MINIMUM_POINTS: 500,
  POINTS_EXPIRY_DAYS: 365,
  STREAK_DAILY_BONUS: 5,
  STREAK_MILESTONE_7: 50,
  STREAK_MILESTONE_30: 200,
  STREAK_MILESTONE_100: 500,
  PRESCREEN_CACHE_DAYS: 30,
  INFERRED_EXPIRY_DAYS: 90,
} as const;
